import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { IBar, IBarWithSelectedTower } from 'app/models/bar';
import * as AppState from '../app.state';
import * as BarActions from './actions'
import * as fromTower from 'app/state/tower/reducer';

export interface State extends AppState.State {
  bar: IBar | null;
  error: string;
}

const initialBarState: State = {
  loading: {},
  bar: null,
  error: ''
};

export const stateName = 'bar';

//#region Reducers
export const reducer = createReducer<State>(
  initialBarState,
  on(BarActions.loadBarSuccess, (state, action): State => {
    return {
      ...state,
      bar: action.bar,
      error: ''
    };
  }),
  on(BarActions.loadBarFailure, (state, action): State => {
    return {
      ...state,
      bar: null,
      error: action.error
    };
  }),
  on(BarActions.clearItem, (state, action): State => {
    return {
      ...state,
      bar: null,
      error: ''
    };
  }),

);
//#endregion Reducers

// #region Selectors
const selectBarFeatureState = createFeatureSelector<State>(stateName);

export const selectBar = createSelector(
  selectBarFeatureState,
  state => state.bar
);


export const selectBarId = createSelector(
  selectBarFeatureState,
  state => state.bar?.id
);

export const isWashingEnabled = createSelector(
  selectBar,
  state => !!state?.useWashing
);

export const displayFullscreenToggle = createSelector(
  selectBar,
  state => !!state?.displayFullscreenToggle
);
export const displayStatistics = createSelector(
  selectBar,
  state => !!state?.displayStatistics
);

export const displayKegPercent = createSelector(
  selectBar,
  state => !!state?.displayKegPercent
);

export const selectBarWithSelectedTower = createSelector(
  fromTower.selectAllEntities,
  selectBar,
  (towers, bar) => {
    if (!bar) return null;
    return {
      ...bar,
      selectedTower: towers[bar.selectedTowerId || ''] || null
    } as IBarWithSelectedTower;
  });



// #endregion Selectors
